<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="用户">
                <!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                             @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="订单编号">
                <el-input style="width: 177px" v-model="queryForm.orderNumber"></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
                <!--                  <el-input  v-model="queryForm.orderStatus"></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    v-model="queryForm.orderStatus"
                    placeholder="请选择"
                    size="small"
                >
                    <el-option v-for="(item,index) in statusList" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付类型">
                <!--                  <el-input  v-model="queryForm.payType"></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    v-model="queryForm.payType"
                    placeholder="请选择"
                    size="small"
                >
                    <el-option v-for="(item,index) in currencyTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="外部交易号">
                <el-input style="width: 177px" v-model="queryForm.payNo"></el-input>
            </el-form-item>
            <el-form-item label="货币类型">
                <!--                  <el-input style="width: 177px" v-model="queryForm.currencyType"></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    v-model="queryForm.currencyType"
                    placeholder="请选择"
                    size="small"
                >
                    <el-option v-for="(item,index) in flowTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getLifeDailyCardOrderList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addLifeDailyCardOrder"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editLifeDailyCardOrder(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteLifeDailyCardOrder(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshLifeDailyCardOrderList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="lifeDailyCardOrderList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderPrice"
                    label="订单金额"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="actualPrice"
                    label="实际金额"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="userId"
                    label="用户"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderNumber"
                    label="订单编号"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderStatus"
                    label="订单状态"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div>{{ returnOrderType(scope.row.orderStatus) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="payType"
                    label="支付类型"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div>{{ returncurrencyType(scope.row.orderStatus) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="payNo"
                    label="外部交易号"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="currencyType"
                    label="货币类型"
                    width="180"
                >
                    <template slot-scope="scope">
                        <div>{{ getFlowType(scope.row.currencyType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkLifeDailyCardOrder(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editLifeDailyCardOrder(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteLifeDailyCardOrder(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="lifeDailyCardOrderStates[lifeDailyCardOrderState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="lifeDailyCardOrder"
                        ref="lifeDailyCardOrderForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="订单金额"
                            prop="orderPrice"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.orderPrice"
                                :disabled="lifeDailyCardOrderState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="实际金额"
                            prop="actualPrice"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.actualPrice"
                                :disabled="lifeDailyCardOrderState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="用户"
                            prop="userId"
                        >
                            <!--            <el-input-->
                            <!--              size="small"-->
                            <!--              v-model="lifeDailyCardOrder.userId"-->
                            <!--              :disabled="lifeDailyCardOrderState == 'check'"-->
                            <!--            ></el-input>-->
                            <GridSelectU style="width: 177px;" labelName="userName" :disabled="lifeDailyCardOrderState == 'check'" title="选择用户"
                                         labelValue="id" :value="lifeDailyCardOrder.userId" :limit='1' size='small' placeholder='请选择用户'
                                         @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="订单编号"
                            prop="orderNumber"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.orderNumber"
                                :disabled="lifeDailyCardOrderState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="订单状态"
                            prop="orderStatus"
                        >
                            <!--            <el-input-->
                            <!--              size="small"-->
                            <!--              v-model="lifeDailyCardOrder.orderStatus"-->
                            <!--              :disabled="lifeDailyCardOrderState == 'check'"-->
                            <!--            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.orderStatus"
                                :disabled="lifeDailyCardOrderState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-option v-for="(item,index) in statusList" :key="index" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="支付类型"
                            prop="payType"
                        >
                            <!--            <el-input-->
                            <!--              size="small"-->
                            <!--              v-model="lifeDailyCardOrder.payType"-->
                            <!--              :disabled="lifeDailyCardOrderState == 'check'"-->
                            <!--            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.payType"
                                :disabled="lifeDailyCardOrderState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-option v-for="(item,index) in currencyTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="外部交易号"
                            prop="payNo"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.payNo"
                                :disabled="lifeDailyCardOrderState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="货币类型"
                            prop="currencyType"
                        >
                            <!--            <el-input
                                          size="small"
                                          v-model="lifeDailyCardOrder.currencyType"
                                          :disabled="lifeDailyCardOrderState == 'check'"
                                        ></el-input>-->
                            <el-select
                                clearable
                                style="width: 177px"
                                v-model="lifeDailyCardOrder.currencyType"
                                :disabled="lifeDailyCardOrderState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-option v-for="(item,index) in flowTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="lifeDailyCardOrderState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetLifeDailyCardOrderList();
                this.getLifeDailyCardOrderList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetLifeDailyCardOrderList();
                this.getLifeDailyCardOrderList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm:{
                orderPrice: '', //订单金额
                actualPrice: '', //实际金额
                userId: '', //用户id
                orderNumber: '', //订单编号
                orderStatus: '', //订单状态
                payType: '', //支付类型
                payNo: '', //外部交易号
                currencyType: '', //货币类型
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            lifeDailyCardOrderState: 'add',
            lifeDailyCardOrderStates: {
                add: '新建油卡订单',
                check: '查看油卡订单',
                edit: '修改油卡订单'
            },

            multipleSelection: [],
            lifeDailyCardOrderList: [],
            lifeDailyCardOrder: {
                id: '', //ID
                orderPrice: '', //订单金额
                actualPrice: '', //实际金额
                userId: '', //用户id
                orderNumber: '', //订单编号
                orderStatus: '', //订单状态
                payType: '', //支付类型
                payNo: '', //外部交易号
                currencyType: '', //货币类型
            },
            btnLoading: false,

            rules: {
                orderPrice: [{ required: true, message: '订单金额不能为空', trigger: 'blur' }],
                actualPrice: [{ required: true, message: '实际金额不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                orderNumber: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
                orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                payType: [{ required: true, message: '支付类型不能为空', trigger: 'blur' }],
                payNo: [{ required: true, message: '外部交易号不能为空', trigger: 'blur' }],
                currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
            },
            statusList: [],
            currencyTypeList: [],
            flowTypeList: [],
        };
    },
    created() {
        this.getLifeDailyCardOrderList();
        this.getEnums();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        getValueUser(value) {
            this.lifeDailyCardOrder.userId = value
        },
        getSeachValueUser(value){
            this.queryForm.userId = value
        },
        resetLifeDailyCardOrderList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.lifeDailyCardOrderList = [];
        },
        getFlowType(type) {
            for (const index in this.flowTypeList) {
                if (this.flowTypeList[index].key == type) {
                    return this.flowTypeList[index].value;
                }
            }
        },
        returncurrencyType(key){
            for (var i = 0; i < this.currencyTypeList.length; i++) {
                if(this.currencyTypeList[i].key == key){
                    return this.currencyTypeList[i].value
                }
            }
        },
        returnOrderType(item) {
            for (const index in this.statusList) {
                if (this.statusList[index].key == item) {
                    return this.statusList[index].value;
                }
            }
        },
        resetDialog() {
            this.lifeDailyCardOrderState = 'add';
            this.showDialog = false;
            this.queryForm = {
                orderPrice: '', //订单金额
                actualPrice: '', //实际金额
                userId: '', //用户id
                orderNumber: '', //订单编号
                orderStatus: '', //订单状态
                payType: '', //支付类型
                payNo: '', //外部交易号
                currencyType: '', //货币类型
            };
            this.getLifeDailyCardOrderList();
        },
        closeDialog() {
            this.showDialog = false
            this.lifeDailyCardOrder = {
                id: '', //ID
                orderPrice: '', //订单金额
                actualPrice: '', //实际金额
                userId: '', //用户id
                orderNumber: '', //订单编号
                orderStatus: '', //订单状态
                payType: '', //支付类型
                payNo: '', //外部交易号
                currencyType: '', //货币类型
            };
        },
        // 获取枚举
        getEnums() {
            get("/life/utils/getEnum", {"enumType": "fuel_card_order_status"}).then((res)=>{
                if(res.success){
                    this.statusList = res.enumList;
                }
            })
            get("/mpp/utils/getEnum",{enumType: "order_pay_type"}).then((res)=>{
                if(res.success){
                    for (let enumListElement of res.enumList) {
                        if(enumListElement.key == 1){
                            enumListElement.value = "抵扣券"
                        }
                    }
                    this.currencyTypeList = res.enumList
                }
            })
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.flowTypeList = res.enumList;
                }
            });
        },
        submitForm() {
            if (this.lifeDailyCardOrderState == 'add') {
                this.$refs.lifeDailyCardOrderForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/life/dailycardorder/add`,{ ...this.lifeDailyCardOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetLifeDailyCardOrderList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.lifeDailyCardOrderState == 'edit') {
                this.$refs.lifeDailyCardOrderForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.lifeDailyCardOrder.user;
                        post(`/life/dailycardorder/edit`,{ ...this.lifeDailyCardOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLifeDailyCardOrderList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addLifeDailyCardOrder() {
            this.showDialog = true;
            this.lifeDailyCardOrderState = 'add';
        },
        checkLifeDailyCardOrder(lifeDailyCardOrderId) {
            console.log(lifeDailyCardOrderId);
            this.currentLifeDailyCardOrderId = lifeDailyCardOrderId;

            this.getLifeDailyCardOrderById();
            this.showDialog = true;
            this.lifeDailyCardOrderState = 'check';
        },
        editLifeDailyCardOrder(lifeDailyCardOrderId) {
            console.log('lifeDailyCardOrder', lifeDailyCardOrderId);
            if (lifeDailyCardOrderId) {
                this.currentLifeDailyCardOrderId = lifeDailyCardOrderId;
                this.getLifeDailyCardOrderById();
            } else {
                this.lifeDailyCardOrder = { ...this.lifeDailyCardOrder, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.lifeDailyCardOrderState = 'edit';
        },
        deleteLifeDailyCardOrder(lifeDailyCardOrderId) {
            let ids = '';
            if (lifeDailyCardOrderId) {
                ids = lifeDailyCardOrderId;
            } else {
                ids = this.multipleSelection.map((lifeDailyCardOrder) => lifeDailyCardOrder.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/life/dailycardorder/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetLifeDailyCardOrderList();
                            this.getLifeDailyCardOrderList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshLifeDailyCardOrderList() {
            this.resetLifeDailyCardOrderList();
            this.getLifeDailyCardOrderList();
        },
        getLifeDailyCardOrderList(query = {}) {
            this.loading = true;
            get(`/life/dailycardorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.lifeDailyCardOrderList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getLifeDailyCardOrderById() {
            get(`/life/dailycardorder/get`,{ id: this.currentLifeDailyCardOrderId }).then((res) =>{
                if(res.success){
                    this.lifeDailyCardOrder = { ...this.lifeDailyCardOrder, ...res.lifeDailyCardOrder };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportLifeDailyCardOrderList() {
            //this.btnLoading = true;
            exprotExcel(`/life/dailycardorder/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/life/dailycardorder/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/life/dailycardorder/importData`,formData);
            this.refreshLifeDailyCardOrderList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getLifeDailyCardOrderList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getLifeDailyCardOrderList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>